import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib';
import { observer } from 'mobx-react';

let styles = require('./CardIcon.scss');

export interface CardIconProps {
    backgroundColor: string;
    iconName: string;
    iconColor: string;
}

/**
 * This is the card Icon shown in the location card header.
 */
@observer
export default class CardIcon extends React.Component<CardIconProps, any> {
    render() {
        const coinBackgroundStyle = {
            backgroundColor: this.props.backgroundColor,
        };

        const iconStyle = {
            color: this.props.iconColor,
        };

        return (
            <div style={coinBackgroundStyle} className={styles.cardIconContainer}>
                <Icon
                    iconName={this.props.iconName}
                    style={iconStyle}
                    className={styles.cardIcon}
                />
            </div>
        );
    }
}
